import { useContext } from "react";
import ServicesContext, { IServices } from "@cayo/shared/services/servicesContext";

export default function useService<K extends keyof IServices>(service: K): IServices[K] {
  const services = useContext(ServicesContext);
  return services[service];
}
